var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEsignGatewaySuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 104,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 52.461,
  cy: 52,
  r: 52,
  fill: "#B7D523"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "m28.266 51.6 15.843 15.862 31.743-31.724"
})));
export { SvgEsignGatewaySuccess as ReactComponent };
export default __webpack_public_path__ + "2cb120028796066b18514459cb4cccda.svg";